import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../components/shared/EmptyState';
import { LayoutGrid } from '../icons';

export function PagePlaceholder({
  title,
  subtitle,
  redirectTo,
}: {
  title: string;
  subtitle?: string;
  redirectTo?: string;
}) {
  const navigate = useNavigate();
  useEffect(() => {
    if (redirectTo) navigate(redirectTo, { replace: true });
  }, [redirectTo, navigate]);

  return (
    <div style={{ padding: 'var(--space-8)' }}>
      <EmptyState
        icon={LayoutGrid}
        title={title}
        description={subtitle ?? '본 페이지는 후속 phase 에서 구현됩니다.'}
      />
    </div>
  );
}
